const stableSerialize = (value) => {
  if (value === null || typeof value !== "object") {
    return JSON.stringify(value);
  }
  if (typeof FormData !== "undefined" && value instanceof FormData) {
    const entries = [];
    for (const [key, entryValue] of value.entries()) {
      if (typeof File !== "undefined" && entryValue instanceof File) {
        entries.push({
          key,
          type: "file",
          name: entryValue.name,
          size: entryValue.size,
          mimeType: entryValue.type,
          lastModified: entryValue.lastModified,
        });
      } else {
        entries.push({
          key,
          type: "value",
          value: entryValue,
        });
      }
    }
    return stableSerialize(entries);
  }
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableSerialize(item)).join(",")}]`;
  }
  const keys = Object.keys(value).sort();
  return `{${keys
    .map((key) => `${JSON.stringify(key)}:${stableSerialize(value[key])}`)
    .join(",")}}`;
};

const hashString = (input) => {
  let hash = 5381;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash * 33) ^ input.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
};

export const createIdempotencyKey = (prefix, payload) => {
  const minuteBucket = Math.floor(Date.now() / 60000);
  const normalizedPayload = stableSerialize(payload || {});
  const payloadHash = hashString(normalizedPayload);
  return `${prefix}:${minuteBucket}:${payloadHash}`;
};
